import { render, staticRenderFns } from "./NavbarAdminPlus.vue?vue&type=template&id=0f004dde&scoped=true"
import script from "./NavbarAdminPlus.vue?vue&type=script&lang=js"
export * from "./NavbarAdminPlus.vue?vue&type=script&lang=js"
import style0 from "./NavbarAdminPlus.vue?vue&type=style&index=0&id=0f004dde&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f004dde",
  null
  
)

export default component.exports